import { React, Fragment } from "react"

const Rainbow = ({ showHeatmapColors }) => {
	return (
		<Fragment>
			<div className="col-12 divBlock mt-4" style={{ display: showHeatmapColors ? "inline" : "none" }}>
				<span className="spanLegend">Target terms</span>
				<div className="boxLegend" style={{ backgroundColor: "#000000" }}></div>
			</div>
			<div className="col-12 divBlock" style={{ display: showHeatmapColors ? "inline" : "none" }}>
				{[...Array(20).keys()].reverse().map((i, index) => (
					<div
						className={`raibow_line ${
							i === 18 ? `raibow_line_up` : i === 1 ? `raibow_line_down` : i > 1 && i < 18 ? `raibow_line_middel` : ""
						}`}
					>
						<span className="spanLegend">{i === 19 ? `High relatedness` : i === 0 ? `Low relatedness` : null}</span>
						<div className="boxLegendR" style={{ backgroundColor: `hsl(${206 - 206 * (i / 20)}, 100%, 50%)` }}></div>
					</div>
				))}
			</div>
			<div className="col-12 divBlock" style={{ display: showHeatmapColors ? "inline" : "none" }}>
				<span className="spanLegend">Ignore terms</span>
				<div className="boxLegend" style={{ backgroundColor: "#E1E1E1" }}></div>
			</div>
		</Fragment>
	)
}
export default Rainbow
